var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { transparentize } from 'polished';
import React from 'react';
import { css, styled } from "../../utils";
export var AutoCompletionsItem = function (_a) {
    var highlight = _a.highlight, value = _a.value, props = __rest(_a, ["highlight", "value"]);
    if (!value)
        return null;
    var selectionStart = value.toLowerCase().indexOf(highlight.toLowerCase());
    if (selectionStart > -1) {
        var selectionEnd = selectionStart + highlight.length;
        var left = value.slice(0, selectionStart);
        var highlighted = value.slice(selectionStart, selectionEnd);
        var right = value.slice(selectionEnd);
        return (React.createElement("li", __assign({}, props),
            React.createElement("span", null, left),
            React.createElement("strong", null, highlighted),
            React.createElement("span", null, right)));
    }
    return React.createElement("li", __assign({}, props), value);
};
var AutoCompletionsList = styled.ul(function (_a) {
    var offset = _a.offset, isOpen = _a.isOpen, colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 1;\n    top: ", "px;\n    left: 0;\n    right: 0;\n    box-shadow: 0 0 7px 0 ", ";\n    border-radius: 5px;\n    margin: 0;\n    background-color: ", ";\n    list-style: none;\n    display: ", ";\n\n    li {\n      padding: 0.5rem 1rem;\n      cursor: pointer;\n\n      &:hover {\n        background-color: ", ";\n      }\n    }\n  "], ["\n    position: absolute;\n    z-index: 1;\n    top: ", "px;\n    left: 0;\n    right: 0;\n    box-shadow: 0 0 7px 0 ", ";\n    border-radius: 5px;\n    margin: 0;\n    background-color: ", ";\n    list-style: none;\n    display: ", ";\n\n    li {\n      padding: 0.5rem 1rem;\n      cursor: pointer;\n\n      &:hover {\n        background-color: ", ";\n      }\n    }\n  "])), offset, transparentize(0.85, colors.black), colors.white, isOpen ? 'block' : 'none', colors.lightGray);
});
var AutoCompletions = function (_a) {
    var offset = _a.offset, _b = _a.autoCompletions, autoCompletions = _b === void 0 ? [] : _b, inputValue = _a.inputValue, onItemClick = _a.onItemClick, renderItem = _a.renderItem, prefix = _a.prefix, customRef = _a.customRef, isOpen = _a.isOpen;
    return (React.createElement(AutoCompletionsList, { "data-component": "AutoCompletions", offset: offset, ref: customRef, isOpen: isOpen }, renderItem ||
        autoCompletions.map(function (value) { return (React.createElement(AutoCompletionsItem, { key: value, value: "" + prefix + value, highlight: inputValue, onClick: function () { return onItemClick("" + prefix + value); } })); })));
};
export default AutoCompletions;
var templateObject_1;
//# sourceMappingURL=AutoCompletions.js.map